'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const XPAreaChart = dynamic(() => import('./XPAreaChart'), { ssr: false });
const CategoryBarChart = dynamic(() => import('./CategoryBarChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-2 gap-6">
      <div className="rounded-xl p-5" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="text-base font-bold text-foreground">XP Progress</h3>
            <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>Last 30 days · +2,840 total XP</p>
          </div>
          <span className="text-xs px-2 py-1 rounded-lg" style={{ background: 'rgba(16,185,129,0.15)', color: '#10B981' }}>
            +34% vs last month
          </span>
        </div>
        <XPAreaChart />
      </div>

      <div className="rounded-xl p-5" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="text-base font-bold text-foreground">Activity by Category</h3>
            <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>Competitions entered this month</p>
          </div>
          <span className="text-xs px-2 py-1 rounded-lg" style={{ background: 'rgba(124,58,237,0.15)', color: '#A78BFA' }}>
            48 total
          </span>
        </div>
        <CategoryBarChart />
      </div>
    </div>
  );
}